import React, {useState} from "react"

import {FieldTableCellProps} from "../../../../../render/table/table-cell"
import FieldRating_TableCellCalculated_Hovered from "./hovered"
import FieldRating_TableCellCalculated_NotHovered from "./not-hovered"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view";

// const debug = "FieldRating_TableCellCalculated"
const debug = false

export default function FieldRating_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)

    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        // Otherwise default = custom field



        // this is for custom fields (!!!)
        // system fields should have their own

        props.listItem.item.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.item.save?.()

        // need decide how to approach this ...
        // i guess some custom fields can do it (based ion type)
        // some not - it' about aggregation
        props.listItem.updateLastUpdateTime?.() // otherwise it wont re-render

        FieldProto_updateView(props.manager, props.field)
    }

    const onMouseEnter = () => {
        if (props.disabled) {
            return
        }

        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldRating_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
                onChange        = {onChange}
            />
        )
    } else {
        return (
            <FieldRating_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
